/**
 * Dynamic helper to convert a section title to its URL-friendly slug.
 * Example: "Premium & Imported" -> "premium-imported"
 * Example: "National Articles" -> "national-articles"
 * @param {string} title - The section title
 * @returns {string} The slugified string
 */
export const slugifySection = (title) => {
  if (!title) return '';
  return title
    .toLowerCase()
    .replace(/&/g, '') // Remove ampersand
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/-+/g, '-') // Collapse multiple consecutive dashes
    .replace(/(^-|-$)/g, ''); // Trim leading and trailing dashes
};

/**
 * Finds the matching section in the sections list by slug.
 * Compares against both the slugified section title and the route field.
 * @param {Array} sections - The list of sections from ViewConfig
 * @param {string} slug - The route slug parameter
 * @returns {Object|null} The matching section object or null
 */
export const getSectionBySlug = (sections = [], slug) => {
  if (!sections || !slug) return null;
  const cleanSlug = slug.toLowerCase().trim();
  
  return sections.find(section => {
    const titleSlug = slugifySection(section.title);
    const routeSlug = section.route ? section.route.split('/').pop() : '';
    return titleSlug === cleanSlug || routeSlug === cleanSlug;
  });
};
